import PhotoAlbum from 'react-photo-album';
import NextJsImage from './NextJsImage';
import { caboPhotos } from './photos';

export default function GalleryGrid() {
  return (
    <PhotoAlbum
      layout="rows"
      photos={caboPhotos}
      renderPhoto={NextJsImage}
      defaultContainerWidth={1200}
      sizes={{ size: 'calc(100vw - 240px)' }}
    />
  );
}
